export default {"src":"/_next/static/media/movr.b86510af.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};